import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, Button, Spinner, Modal } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from "../../common/Avatar";
import { item, list } from "../../../lib/api/competition";
import { Add } from './Add';
import { Edit } from './Edit';
import { List as ClubsList} from './Clubs';
import { GenerateSchedule } from './GenerateSchedule';
import OfficialRates from './OfficialRates';
import {currentSeason} from '../../../lib/api/season';

import CardDropdown from 'components/common/CardDropdown';
import { Dropdown } from 'react-bootstrap';
import {_exportPDF} from "../../../lib/api/api";

export const List = () => {
    const [competitions, setCompetitions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedCompetition, setSelectedCompetition] = useState(null);
    const [showModalClubs, setShowModalClubs] = useState(false);
    const [selectedCompetitionClubs, setSelectedCompetitionClubs] = useState({});
    const [showGenerateModal, setShowGenerateModal] = useState(false);
    const [selectedCompetitionGenerate, setSelectedCompetitionGenerate] = useState(null);
    const [season, setSeason] = useState([]);
    const [ratesCompetition, setRatesCompetition] = useState(null);

    const handleNew = () => {
        setSelectedCompetition(null);
        setShowModal(true);
    };

    const handleEdit = async (id) => {
        setIsLoading(true);
        try {
            const resCompetition = await item({ competitions_guid: id });
            const competition = Array.isArray(resCompetition) ? resCompetition[0] : resCompetition;
            setSelectedCompetition(competition);
            setShowModal(true);
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClubsAdd = (id) => {
        const competition = competitions.find(c => c.competitions_guid === id);
        console.log('competition',competition)
        setSelectedCompetitionClubs(competition);
        setShowModalClubs(true);
    };

    const handleGenerateSchedule = async (id) => {
        setIsLoading(true);
        try {
            const resCompetition = await item({ competitions_guid: id });
            const competition = Array.isArray(resCompetition) ? resCompetition[0] : resCompetition;
            setSelectedCompetitionGenerate(competition);
            setShowGenerateModal(true);
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };


    const getCompetitions = () => {
        setIsLoading(true);
        list()
            .then((res) => setCompetitions(res))
            .catch((err) => console.error(err))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        const fetchData = async () => {
            await getCompetitions();
            const resSeason = await currentSeason();
            setSeason(resSeason);
        };
        fetchData();
    }, []);

    const matchScheduleToPdf = async (competitions_guid) => {
        return await _exportPDF(`report/pdf-match-schedule?competitions_guid=${competitions_guid}`, undefined, false, 'GET');
    };

    const renderActions = item => (
        <CardDropdown>
            <div className="py-2">
                <Dropdown.Item onClick={() => handleClubsAdd(item.competitions_guid)}>Lista klubove za takmičenje</Dropdown.Item>
                <Dropdown.Divider/>
                <Dropdown.Item onClick={() => handleEdit(item.competitions_guid)}>Izmjeni takmičenja</Dropdown.Item>
                {[2, 3].includes(Number(item.competition_system_type_id)) && (
                    <>
                        <Dropdown.Divider/>
                        <Dropdown.Item onClick={() => handleGenerateSchedule(item.competitions_guid)}>
                            Generiši Berger Raspored
                        </Dropdown.Item>
                    </>
                )}
                <Dropdown.Divider/>
                <Dropdown.Item onClick={() => matchScheduleToPdf(item.competitions_guid)}>
                    Štampa rasporeda utakmica
                </Dropdown.Item>
                <Dropdown.Divider/>
                <Dropdown.Item onClick={() => setRatesCompetition(item)}>
                    Unos cjenovnika
                </Dropdown.Item>
            </div>
        </CardDropdown>
    );

    return (
        <Card className={classNames('h-100')}>
            <Card.Header>
                <Row className={classNames('g-2')}>
                    <Col>
                        <Flex>
                            <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                                Takmičenja {season.length > 0 ? `- ${season[0].name}` : ''}
                            </h5>
                        </Flex>
                    </Col>
                    <Col xs="auto">
                        <Button onClick={handleNew} variant="primary">
                            Dodaj takmičenje
                        </Button>
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body className="bg-body-tertiary">
                {isLoading ? (
                    <div className="text-center">
                        <Spinner animation="border" role="status" />
                    </div>
                ) : (
                    <Row className="mb-3">
                        <div className="d-none d-xl-block">
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th scope="col">Vrsta</th>
                                    <th scope="col">Naziv</th>
                                    <th scope="col">Pol</th>
                                    <th scope="col">Selekcija</th>
                                    <th scope="col">Kola</th>
                                    <th className="text-end" scope="col">Akcija</th>
                                </tr>
                                </thead>
                                <tbody>
                                {competitions.map((item, i) => (
                                    <tr key={i}>
                                        <td>
                                            <div className="ms-2">{item.type_name}</div>
                                        </td>
                                        <td>
                                            <div className="ms-2">{item.name}</div>
                                        </td>
                                        <td>
                                            <div className="ms-2">{item.gender_name}</div>
                                        </td>
                                        <td>
                                            <div className="ms-2">{item.selection_name}</div>
                                        </td>
                                        <td>
                                            <div className="ms-2">
                                                {Number(item.competition_rounds_count) === 0 ? '' : item.competition_rounds_count}
                                            </div>
                                        </td>
                                        <td className="text-end">{renderActions(item)}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </div>

                        <div className="d-xl-none">
                            <Row className="g-3">
                                {competitions.map((item, i) => (
                                    <Col xs={12} key={item.competitions_guid || i}>
                                        <div
                                            className="border rounded-4 bg-white h-100 p-3 shadow-sm cursor-pointer"
                                            style={{ borderColor: '#dfe3ee' }}
                                            onClick={() => handleClubsAdd(item.competitions_guid)}
                                        >
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                                    <div className="fw-semibold text-dark fs-8">
                                                        {item.name || '-'}
                                                    </div>
                                                </div>
                                                <div
                                                    className="flex-shrink-0"
                                                    onClick={event => event.stopPropagation()}
                                                >
                                                    {renderActions(item)}
                                                </div>
                                            </div>

                                            <div className="d-flex flex-wrap gap-2 mt-2">
                                                <span className="badge rounded-pill badge-subtle-primary">
                                                    {item.type_name || '-'}
                                                </span>
                                                <span className="badge rounded-pill badge-subtle-success">
                                                    {item.gender_name || '-'}
                                                </span>
                                            </div>

                                            <div className="text-700 fs-10 mt-2">
                                                {item.selection_name || '-'}
                                            </div>

                                            <div className="text-600 fs-10 mt-1">
                                                Kola: {Number(item.competition_rounds_count) === 0 ? '-' : item.competition_rounds_count}
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Row>
                )}
            </Card.Body>

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{selectedCompetition ? 'Izmijeni takmičenje' : 'Dodaj takmičenje'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedCompetition? (
                        <Edit
                            initialData={selectedCompetition}
                            onClose={() => setShowModal(false)}
                            onSave={getCompetitions}
                        />
                    ) : (
                        <Add
                            onClose={() => setShowModal(false)}
                            onSave={getCompetitions}
                        />
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showModalClubs} onHide={() => setShowModalClubs(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{selectedCompetitionClubs && selectedCompetitionClubs.name ? selectedCompetitionClubs.name : ''}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedCompetitionClubs && (
                        <ClubsList
                            initialData={selectedCompetitionClubs}
                            onClose={() => setShowModalClubs(false)}
                            onSave={getCompetitions}
                        />
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showGenerateModal} onHide={() => setShowGenerateModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Generiši Berger Raspored</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedCompetitionGenerate && (
                        <GenerateSchedule
                            initialData={selectedCompetitionGenerate}
                            onClose={() => setShowGenerateModal(false)}
                            onSave={getCompetitions}
                        />
                    )}
                </Modal.Body>
            </Modal>

            {ratesCompetition && (
                <OfficialRates
                    competition={ratesCompetition}
                    onClose={() => setRatesCompetition(null)}
                />
            )}
        </Card>
    );
};

export default List;
